/**
 * Oprávnění modulu Planner (zrcadlí backend `VenuaPlannerPermissions.Agenda`).
 * Jeden uzel katalogu s úrovněmi: `read` = zobrazení agendy (menu, gate), `edit` = úpravy.
 */
export const PLANNER_PERMISSION = 'products.venua-planner';
